import { AcademicPeriod } from '@/plugins/api'
import alert from '@/plugins/alert'
import get from 'lodash-es/get'
export default {
  namespaced: true,
  state: {
    academicPeriods: [],
    query: {},
    academicPeriod: {},
  },
  actions: {
    async fetchAcademicPeriods({ commit }, options) {
      try {
        commit('setAcademicPeriods', await AcademicPeriod.fetch(options))
      } catch (error) {
        alert.error(error)
      }
    },
    async fetchAcademicPeriodsIndependent(_, options) {
      return await AcademicPeriod.fetch(options)
    },
    async createAcademicPeriod({ commit }, data) {
      try {
        commit('createAcademicPeriod', await AcademicPeriod.create(data))
      } catch (e) {
        alert.error(e)
      }
    },
    async removeAcademicPeriod({ commit }, id) {
      try {
        await AcademicPeriod.remove(id)
        commit('removeAcademicPeriod', id)
        alert.success('Xóa thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async updateAcademicPeriod({ commit }, { id, ...academicPeriod }) {
      try {
        const g = await AcademicPeriod.update(id, academicPeriod)
        commit('updateAcademicPeriod', g)
        alert.success('Cập nhật thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    updateAcademicPeriodIndependent(_, { id, ...academicPeriod }) {
      return AcademicPeriod.update(id, academicPeriod)
    },
    setQuery({ commit }, data) {
      commit('setQuery', data)
    },
    async fetchOneAcademicPeriod({ commit }, id) {
      commit('setAcademicPeriod', await AcademicPeriod.fetchOne(id))
    },
  },
  mutations: {
    setAcademicPeriods(state, academicPeriods) {
      state.academicPeriods = academicPeriods
    },
    updateAcademicPeriod(state, academicPeriod) {
      state.academicPeriods = state.academicPeriods.map((g) => {
        if (academicPeriod.id === g.id) return academicPeriod
        else return g
      })
    },
    createAcademicPeriod(state, academicPeriod) {
      state.academicPeriods = [academicPeriod, ...state.academicPeriods]
    },
    removeAcademicPeriod(state, id) {
      state.academicPeriods = state.academicPeriods.filter((academicPeriod) => academicPeriod.id !== id)
    },
    setQuery(state, data) {
      state.query = data
    },
    setAcademicPeriod(state, academicPeriod) {
      state.academicPeriod = academicPeriod
    },
  },
  getters: {
    getExamCondition(state) {
      return get(state, 'academicPeriod.examCondition')
    },
    getAcademicPeriod(state) {
      return state.academicPeriod
    },
  },
}
